const isValidRange = (
  range: [number, number] | null
): range is [number, number] => {
  return (
    range !== null &&
    !Number.isNaN(range[0]) &&
    !Number.isNaN(range[1]) &&
    range[0] < range[1]
  );
};

const isSameRange = (
  range1: [number, number] | null,
  range2: [number, number] | null
): boolean => {
  return (
    (range1 === null && range2 === null) ||
    (range1?.[0] === range2?.[0] && range1?.[1] === range2?.[1])
  );
};

// 範囲1が範囲2の左側に内接しているかどうかを判定する
const isLeftInscribed = (
  range1: [number, number],
  range2: [number, number] | null
): range2 is [number, number] => {
  return (
    range1 !== null &&
    range2 !== null &&
    range1[0] === range2[0] &&
    range1[1] <= range2[1]
  );
};

// 範囲1が範囲2の右側に内接しているかどうかを判定する
const isRightInscribed = (
  range1: [number, number],
  range2: [number, number] | null
): range2 is [number, number] => {
  return (
    range1 !== null &&
    range2 !== null &&
    range1[0] >= range2[0] &&
    range1[1] === range2[1]
  );
};

// 範囲1が範囲2の左端に連続しているかを判定する
const isLeftContinuous = (
  range1: [number, number],
  range2: [number, number] | null
): range2 is [number, number] => {
  return range1 !== null && range2 !== null && range1[1] === range2[0];
};

// 範囲1が範囲2の右端に連続しているかを判定する
const isRightContinuous = (
  range1: [number, number],
  range2: [number, number] | null
): range2 is [number, number] => {
  return range1 !== null && range2 !== null && range1[0] === range2[1];
};

// クリックした範囲に応じて、選択範囲を縮小・拡大した新しい選択範囲を返す
const toggleRange = (
  clickedRange: [number, number],
  currentRange: [number, number] | null
): [number, number] | null => {
  if (isSameRange(clickedRange, currentRange)) {
    // 同じ範囲を再クリックした場合、選択を解除する
    return null;
  }
  if (isLeftInscribed(clickedRange, currentRange)) {
    // 左端の範囲をクリックした場合、その範囲を除外する
    return [clickedRange[1], currentRange[1]];
  }
  if (isRightInscribed(clickedRange, currentRange)) {
    // 右端の範囲をクリックした場合、その範囲を除外する
    return [currentRange[0], clickedRange[0]];
  }
  if (isLeftContinuous(clickedRange, currentRange)) {
    // 左端に連続する範囲をクリックした場合、選択範囲を左側に拡大する
    return [clickedRange[0], currentRange[1]];
  }
  if (isRightContinuous(clickedRange, currentRange)) {
    // 右端に連続する範囲をクリックした場合、選択範囲を右側に拡大する
    return [currentRange[0], clickedRange[1]];
  }
  // それ以外の場合、クリックした範囲を新しい選択範囲にする
  return clickedRange;
};

export {
  isValidRange,
  isSameRange,
  isLeftInscribed,
  isRightInscribed,
  isLeftContinuous,
  isRightContinuous,
  toggleRange,
};
